var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLangs = function SvgLangs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1392,
    height: 581,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.273,
    height: 41.273,
    fill: "#50BF91",
    rx: 8,
    transform: "matrix(-1 0 0 1 495.273 73)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.988,
    height: 33.988,
    fill: "#50BF91",
    rx: 8,
    transform: "matrix(-1 0 0 1 83.975 404.489)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.988,
    height: 33.988,
    fill: "#FFB800",
    rx: 8,
    transform: "matrix(-1 0 0 1 63.988 42)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.988,
    height: 33.988,
    fill: "#3BBDCF",
    rx: 8,
    transform: "matrix(-1 0 0 1 1361.71 454.409)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.988,
    height: 33.988,
    fill: "#3BBDCF",
    rx: 8,
    transform: "matrix(-1 0 0 1 930.488 387.495)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.443,
    height: 56.443,
    fill: "#FFB800",
    rx: 8,
    transform: "matrix(-1 0 0 1 896.65 20)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__g)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.988,
    height: 33.988,
    fill: "#3B7CC9",
    rx: 8,
    transform: "matrix(-1 0 0 1 1314.99 43)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.349,
    height: 74.349,
    fill: "#50BF91",
    rx: 16,
    transform: "matrix(-1 0 0 1 1238.35 313)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__i)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.349,
    height: 74.349,
    fill: "#FFB800",
    rx: 16,
    transform: "matrix(-1 0 0 1 423.857 466.092)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1203.48 334.069c-.54-1.41-1.87-2.337-3.36-2.335a3.59 3.59 0 0 0-3.36 2.328l-11.02 29.244a2.97 2.97 0 0 0 1.7 3.827 2.916 2.916 0 0 0 3.78-1.716l2.03-5.372h13.65l2 5.364c.57 1.548 2.31 2.303 3.79 1.728a2.97 2.97 0 0 0 1.7-3.823zm-8 20.043 4.63-12.268 4.58 12.268z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1351.72 465.645h-5.5v-2.376c0-.787-.67-1.426-1.5-1.426s-1.5.639-1.5 1.426v2.376h-5.5c-.83 0-1.5.638-1.5 1.425s.67 1.426 1.5 1.426h1c.01 3.076 1.29 5.881 3.39 7.946-.8.313-1.65.525-2.55.614-.82.083-1.42.784-1.33 1.567.08.732.73 1.277 1.49 1.277.05 0 .1-.003.16-.008 1.76-.177 3.4-.703 4.84-1.502 1.44.799 3.08 1.325 4.84 1.502.05.005.11.008.16.008.76 0 1.41-.545 1.49-1.277.08-.783-.51-1.484-1.34-1.567a9.5 9.5 0 0 1-2.54-.614c2.09-2.065 3.37-4.87 3.39-7.946h1c.82 0 1.49-.639 1.49-1.426s-.67-1.425-1.49-1.425m-7 9.229c-1.84-1.579-2.99-3.857-3-6.378h6c-.02 2.521-1.16 4.799-3 6.378M883.755 48.147c0-8.506-6.895-15.401-15.401-15.401s-15.401 6.895-15.401 15.4 6.895 15.402 15.401 15.402 15.401-6.896 15.401-15.401"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M868.355 32.745c-6.622 0-12.267 4.18-14.443 10.044h28.886c-2.176-5.864-7.821-10.044-14.443-10.044"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M868.355 63.548c6.622 0 12.267-4.18 14.443-10.044h-28.886c2.176 5.864 7.821 10.044 14.443 10.044"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.981 429.98a8.498 8.498 0 1 0 0-16.995 8.498 8.498 0 0 0 0 16.995"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M75.479 421.483a8.5 8.5 0 0 0-5.541-7.968v15.937a8.5 8.5 0 0 0 5.541-7.969"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#47A56C",
    d: "M58.484 421.483a8.5 8.5 0 0 0 5.542 7.968v-15.936a8.5 8.5 0 0 0-5.542 7.968"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M485.863 93.71c0 6.16-4.993 11.153-11.152 11.153s-11.152-4.993-11.152-11.153c0-6.159 4.993-11.152 11.152-11.152s11.152 4.993 11.152 11.152"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE601",
    d: "M474.713 104.864c-4.796 0-8.883-3.027-10.459-7.274h20.917c-1.576 4.247-5.663 7.274-10.458 7.274"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#151515",
    d: "M474.713 82.559c4.795 0 8.882 3.026 10.458 7.273h-20.917c1.576-4.247 5.663-7.273 10.459-7.273"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M921.99 404.489a8.497 8.497 0 0 1-8.497 8.497 8.497 8.497 0 0 1-8.497-8.497 8.497 8.497 0 0 1 8.497-8.497 8.497 8.497 0 0 1 8.497 8.497"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M917.743 404.489a4.248 4.248 0 1 1-8.496 0 4.248 4.248 0 0 1 8.496 0"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#langs_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.667 525.571c12.325 0 22.317-9.992 22.317-22.317 0-12.326-9.992-22.317-22.317-22.317-12.326 0-22.317 9.991-22.317 22.317 0 12.325 9.991 22.317 22.317 22.317"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    fillRule: "evenodd",
    d: "M408.795 500.343h-19.217v-19.217a22.6 22.6 0 0 0-5.822 0v19.217h-19.217a22.4 22.4 0 0 0 0 5.822h19.217v19.217a22.6 22.6 0 0 0 5.822 0v-19.217h19.217a22.6 22.6 0 0 0 0-5.822m-16.307 8.733 9.958 9.959a23 23 0 0 0 1.312-1.433l-8.526-8.526zm-11.643 0v2.744l-8.526 8.526a22 22 0 0 1-1.433-1.311zm.001-11.644-9.959-9.959a23 23 0 0 0-1.312 1.433l8.526 8.526zm21.6-9.959-9.958 9.959v-2.744l8.526-8.526q.745.624 1.432 1.311",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    fillRule: "evenodd",
    d: "M392.49 481.706a22.2 22.2 0 0 1 7.765 3.844l-7.765 7.765zm-27.371 15.726a22.2 22.2 0 0 1 3.845-7.765l7.765 7.765zm39.252-7.765a22.3 22.3 0 0 1 3.844 7.765h-11.61zm-39.252 19.409a22.2 22.2 0 0 0 3.845 7.765l7.765-7.765zm7.962 11.881a22.2 22.2 0 0 0 7.765 3.845v-11.61zm0-35.407a22.2 22.2 0 0 1 7.765-3.844v11.609zm19.409 39.252a22.25 22.25 0 0 0 7.765-3.844l-7.765-7.766zm11.881-7.961-7.766-7.765h11.61a22.3 22.3 0 0 1-3.844 7.765",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M1306.49 59.994c0 4.693-3.8 8.497-8.49 8.497-4.7 0-8.5-3.804-8.5-8.497s3.8-8.497 8.5-8.497c4.69 0 8.49 3.804 8.49 8.497"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE451",
    d: "m1301.44 58.352-2.21-.21a.39.39 0 0 1-.32-.235l-.79-1.923a.384.384 0 0 0-.71 0l-.79 1.923a.36.36 0 0 1-.31.235l-2.22.21c-.33.032-.46.444-.22.667l1.67 1.466c.11.096.16.235.12.375l-.5 2.057c-.07.324.28.59.57.419l1.85-1.086a.37.37 0 0 1 .38 0l1.85 1.086c.29.171.64-.089.57-.42l-.5-2.056c-.03-.14.01-.28.12-.375l1.67-1.466c.24-.223.1-.635-.23-.667"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.835 51.473c-.214-.59-.751-.977-1.352-.976-.6 0-1.135.385-1.35.973l-4.434 12.216c-.232.64.074 1.355.683 1.599s1.291-.078 1.523-.717l.815-2.244h5.493l.806 2.24c.23.647.927.963 1.521.722.61-.241.918-.956.688-1.596zm-3.216 8.372 1.86-5.125 1.843 5.125z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__a",
    width: 101.273,
    height: 101.273,
    x: 424,
    y: 53,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__b",
    width: 93.988,
    height: 93.988,
    x: 19.986,
    y: 384.489,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__c",
    width: 93.988,
    height: 93.988,
    x: 0,
    y: 22,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__d",
    width: 93.988,
    height: 93.988,
    x: 1297.72,
    y: 434.409,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__e",
    width: 93.988,
    height: 93.988,
    x: 866.5,
    y: 367.495,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__f",
    width: 116.443,
    height: 116.443,
    x: 810.207,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__g",
    width: 93.988,
    height: 93.988,
    x: 1251,
    y: 23,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__h",
    width: 134.35,
    height: 134.349,
    x: 1134,
    y: 293,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__i",
    width: 134.35,
    height: 134.349,
    x: 319.508,
    y: 446.092,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__j",
    width: 103.386,
    height: 109.943,
    x: 1150.5,
    y: 303.057,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.124,
    dy: 8.497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "langs_svg__k",
    width: 118.983,
    height: 118.983,
    x: 329.3,
    y: 452.259,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.124,
    dy: 8.497
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_942_22547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_942_22547",
    result: "shape"
  })))));
};
export default SvgLangs;